<template>
  <div class="search-detail">
    <div class="header-paper clearfix">
      <div class="container-fluid">
        <div class="row margin-b-5">
          <label class="col-sm-1 control-label align-right">{{ labels['HRMS32EC1']['30'] }}</label>
          <div class="col-sm-3">     
            <hrms-lov v-model="paramSearchDetail.codempid_query"
                      lovType="codempid"
                      :nowLang="nowLang"
                      name="codempid"
                      :disabled="eventBtn === 'edit'"
                      :descDisp="true"
                      :desc="descCodempidQuery"
                      v-validate="'required'"
                      :has-error="errors.has('codempid')"  /> 
            <div class="text-error" v-show="errors.has('codempid')">{{errors.first('codempid')}}</div>
          </div>
          <label class="col-sm-1 control-label align-right">{{ labels['HRMS32EC1']['50'] }}</label>
          <div class="col-sm-3">
            <hrms-datepicker  v-model="paramSearchDetail.dtereq"
                              v-validate="'required|date_format:DD/MM/YYYY'"
                              data-vv-value-path="inputDate"
                              name="dtereq"
                              :has-error="errors.has('dtereq')" 
                              style="margin-bottom:5px;"
                              @keyup.enter.native="validateDetailTab1()" />
            <div class="text-error" v-show="errors.has('dtereq')">{{errors.first('dtereq')}}</div>    
          </div>
          <label class="col-sm-1 control-label align-right">{{ labels['HRMS32EC1']['180'] }}</label>
          <div class="col-sm-3">
            <div class="form-control readonly-field-color">{{ currentCodempid }} {{ descCodempid }}</div>  
          </div>
        </div>

      </div>
      
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'search-detail',
  props: [ 'labels', 'nowLang', 'currentCodempid', 'descCodempid', 'receivedHrms32eDetailTab1Create', 'receivedHrms32eDetailTab2_6Create', 'indexSelected', 'searchDetail', 'eventBtn' ],
  data () {
    return {
      paramSearchDetail: {
        codempid_query: this.currentCodempid,
        dtereq: moment().format('DD/MM/YYYY')
      }
    }
  },
  watch: {
    'searchDetail.dtereq' (newVal) {
      this.paramSearchDetail.dtereq = newVal
    },
    'searchDetail.codempid_query' (newVal) {
      this.paramSearchDetail.codempid_query = newVal
    },
    'paramSearchDetail.dtereq' (newVal) {
      this.$set(this.searchDetail, 'dtereq', newVal)
    },
    'paramSearchDetail.codempid_query' (newVal) {
      this.$set(this.searchDetail, 'codempid_query', newVal)
      if (this.eventBtn === 'add' && newVal !== '') {
        this.receivedHrms32eDetailTab1Create(this.paramSearchDetail)
        this.receivedHrms32eDetailTab2_6Create(this.paramSearchDetail)
        this.indexSelected.codempid = newVal
      }
    }
  },
  methods: {
    validateDetailTab1 () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          if (_this.eventBtn === 'add') {
            _this.receivedHrms32eDetailTab1Create(_this.paramSearchDetail)
            _this.receivedHrms32eDetailTab2_6Create(_this.paramSearchDetail)
          }
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// searchDetail.vue?128ebd96